import { WITHDRAWAL_STATUS_CHECK_LIVE, WITHDRAWAL_STATUS_CHECK_LIVE_UPDATE } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const getWithdrawalStatusCheckLive = (payload) => {
  return apiInstance.post(WITHDRAWAL_STATUS_CHECK_LIVE, payload);
};
export const getWithdrawalStatusCheckLiveUpdate = (payload) => {
  return apiInstance.post(WITHDRAWAL_STATUS_CHECK_LIVE_UPDATE, payload);
};
